// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls-module__BuildControls__Y0WFG","OrderButton":"BuildControls-module__OrderButton__20rGy","enable":"BuildControls-module__enable__YuBb_"};